import { renderBasemapSnapshot } from "./basemap";

let observer: IntersectionObserver | undefined;
let generation: AbortController | undefined;
let queue: Promise<void> = Promise.resolve();
const cache = new Map<string, HTMLCanvasElement>();

/** Render visible cards serially so a long catalogue never exhausts WebGL contexts. */
export function fillBasemapThumbnails(root: HTMLElement): void {
  observer?.disconnect();
  generation?.abort();
  const controller = new AbortController();
  generation = controller;
  observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer?.unobserve(entry.target);
      const target = entry.target as HTMLCanvasElement;
      queue = queue.then(async () => {
        if (controller.signal.aborted || !target.isConnected) return;
        const lat = Number(target.dataset.basemapLat);
        const lon = Number(target.dataset.basemapLon);
        if (!Number.isFinite(lat) || !Number.isFinite(lon)) return;
        const width = target.clientWidth || 280;
        const height = target.clientHeight || 148;
        const key = `${lat}:${lon}:${width}:${height}:${window.devicePixelRatio}`;
        let canvas = cache.get(key);
        if (!canvas) {
          const snapshot = await renderBasemapSnapshot({ width, height, center: [lon, lat], zoom: 9, signal: controller.signal });
          if (!snapshot) return;
          canvas = snapshot.canvas;
          cache.set(key, canvas);
          if (cache.size > 48) cache.delete(cache.keys().next().value!);
        }
        if (controller.signal.aborted || !target.isConnected) return;
        target.width = canvas.width;
        target.height = canvas.height;
        target.getContext("2d")?.drawImage(canvas, 0, 0);
      }).catch(() => { /* The card still has its location label if the map is unavailable. */ });
    }
  }, { rootMargin: "100px" });
  root.querySelectorAll("canvas[data-basemap-lat]").forEach((canvas) => observer!.observe(canvas));
}
